<app-modal [noPadding]="true">
  <ng-template #TITLE> Private Packages Access</ng-template>
  <section content>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="login-card py-3 px-2 px-md-4 bg-white text-center">
            @if (messages$ | async; as messages) {
            <div class="success-message alert alert-danger text-center mb-5">
              <app-error-handler [errors]="messages"></app-error-handler>
            </div>
            }
            <form (ngSubmit)="onSubmit()" [class.loading]="loading" [formGroup]="form">
              <app-input
                [invalidMessages]="['Please enter your username']"
                formControlName="username"
                label="Username"
                required
                type="text"
                autocomplete="off"
                uniqueId="private-packages-login-form-username"
              ></app-input>
              <app-input
                [invalidMessages]="['Please enter your password']"
                formControlName="password"
                label="Password"
                required
                type="password"
                autocomplete="off"
                uniqueId="private-packages-login-form-password"
              ></app-input>
              <div class="form-check text-start mt-3 mb-2">
                <input
                  (click)="onAgreeClick($event, terms)"
                  class="form-check-input cursor-pointer"
                  formControlName="agree"
                  id="private-packages-login-form-agree"
                  type="checkbox"
                />
                <label class="form-check-label fs-sm" for="private-packages-login-form-agree">I agree to the</label>
                <button
                  (click)="terms.showModal()"
                  aria-haspopup="dialog"
                  class="btn btn-link link-black text-decoration-underline align-baseline p-0 fs-sm"
                  id="private-packages-login-form-terms-link"
                  type="button"
                >
                  Terms &amp; Conditions
                </button>
              </div>
              <div class="align-items-center d-flex flex-column">
                <button [disabled]="form.invalid || loading" class="btn btn-primary btn-lg mt-2">
                  @if (loading) {
                  <app-inline-loader />
                  } @else { Login }
                </button>
              </div>
            </form>
            <dialog
              #terms
              aria-labelledby="private-packages-login-form-terms-title"
              class="border-0 rounded p-4 text-start"
              id="private-packages-login-form-terms"
              style="max-width: 34rem"
            >
              <h5 class="mb-3" id="private-packages-login-form-terms-title">Terms &amp; Conditions</h5>
              <p class="fs-sm">
                By accessing these exclusive Charity Booster packages, I acknowledge that the information is proprietary
                and confidential to Charity Booster. I agree not to share, distribute, or provide these packages or
                related information to any Charity Booster competitor. I understand these exclusive packages are
                provided to help ensure winning bidders have a positive experience and minimize potential availability
                issues. Thank you for respecting the value of these packages and helping us support our
                auctioneer/nonprofit partners&mdash;we appreciate you!
              </p>
              <div class="d-flex justify-content-end gap-2">
                <button (click)="terms.close()" class="btn btn-outline-secondary" type="button">Close</button>
                <button
                  (click)="form.patchValue({ agree: true }); terms.close()"
                  class="btn btn-primary"
                  id="private-packages-login-form-terms-agree"
                  type="button"
                >
                  I Agree
                </button>
              </div>
            </dialog>
          </div>
        </div>
      </div>
    </div>
  </section>
</app-modal>
